<template>
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">关于我们</span>
        <h1 class="c-text-left">以研究为导向的机器人公司</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          Franka Robotics是一家来自德国的技术驱动型机器人公司，总部位于慕尼黑，并在全球范围内运营。公司成立于2016年，自2023年起加入思灵机器人集团。
        </span>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          我们的使命是赋能快速发展的机器人与人工智能专业社群，致力于为全球机器人与人工智能领域的前沿研究者提供研究平台。通过开放性的专业机器人平台与模块化设计的用户界面，助力科研机构与创新企业不断发展机器人及人工智能领域等技术，加速创新成果转化。
        </span>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          Franka Robotics致力于构建一个智能未来，让具备物理交互能力的AI系统深度融入人类生活场景，在医疗康养、智能制造、家庭服务等关键领域持续创造社会价值，为人类服务。
        </span> 
          <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10"> 
            <!-- <div class="buttonSite" > -->
              <router-link to="/contact" class="buttonSite">联系我们</router-link>
            <!-- </div> -->
          </div>
      </div>
  
      <div class="display-width">
        <img src="@/assets/images/company/_Frank Robotics0615_resized-1.jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>
    
    <div id="resources-productdocumentation"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">新闻及活动</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap">  
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10 c-mt-40">会议、里程碑、产品发布</span>
        <h1 class="c-text-left">关注我们最新动态</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          了解机器人领域的最新发展、突破和事件。在这里，您可以找到我们当前项目的信息、即将举行的活动以及行业新闻。
        </span>
        
        <div class="linkTag c-pos-relative">
          关注我们的官方微信公众号！
          <img class="wechat-image" src="@/assets/images/focus/dcf3e7df86e4614d1fbc7f53a5ade7f4.jpg" alt="微信公众号" />
        </div>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-40"> 
            <div class="buttonSite c-mr-10" style="width: 100px;">
              <router-link to="/news">新闻</router-link>
            </div>
            <div class="buttonSite" style="width: 100px;">
              <router-link to="/events">事件</router-link>
            </div>
        </div>
         
      </div> 
      <div class="display-width">
        <img src="@/assets/images/events/1ce8d8f9900d36c522ff6123a64358d.jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
   
    </div> 
    <div id="resources-development"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">职业生涯</span>
      <hr class="divider">
    </div>
    
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width">
        <img src="@/assets/images/company/image (3).png" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">FRANKA ROBOTICS，创新与人才的汇聚地</span>
        <h1 class="c-text-left">我们的公司，我们的团队</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          无论您是工程师、设计师、经理还是开发人员——都可以成为我们才华横溢团队的一员！我们寻找拥有多元背景和专业知识的人才，与我们共同成长。
        </span> 
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10"> 
          <!-- <div class="buttonSite" >
            匹配职位
          </div> -->
        </div>
      </div>   
    </div>
 
    <div id="resources-community"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">销售伙伴</span>
      <hr class="divider">
    </div>
    
    <div class="c-text-between px-container c-flex-wrap" >  
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">寻找或成为销售伙伴</span>
        <h1 class="c-text-left">一个持续增长的全球网络</h1>
        <span class="c-mt-10 c-mb-5 c-text-left text-indent">
          我们为与一群充满热情的合作伙伴一起工作而感到自豪，他们与我们共享对机器人技术和创新的热情。在本页面上，您将找到有关我们现有和未来销售伙伴的资源和信息。
        </span>  
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10"> 
          <!-- <div class="buttonSite"> -->
            <router-link to="/contact" class="buttonSite">成为合作伙伴</router-link>
          <!-- </div>  -->
        </div>
      </div>   
      <div class="display-width">
        <img src="@/assets/images/company/Image (69)-4 (1).png" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>

  </template>
  
  <script>
  // import HelloWorld from './components/HelloWorld.vue'
  
  export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
    name: 'App',
    components: {
      // HelloWorld
    },
    data(){
      return {  
        
      }
    }, 
  }
  </script>
  
  <style scoped>
  
  .display-width{
    width: calc(50% - 40px);
  }
  
@media (max-width: 1029px) {
  }
  
  /* 屏幕宽度小于 900px 时，一行展示 2 个 */
  @media (max-width: 899px) {
    .display-width{
      width: 100%
    }
  }
  
  /* 屏幕宽度小于 600px 时，一行展示 1 个 */
  @media (max-width: 599px) {
  }
  
  </style>
  <style scoped> 
  /* h2 {
    font-size: 14px;
    margin-top: 10px;
    color: #333;
  } */
.wechat-image {
  display: none;
  position: absolute;
  bottom: 25px;
  left: 50%;
  width: 120px;
  height: auto;
  transform: translateX(-50%);
}

.linkTag:hover .wechat-image {
  display: block; /* 鼠标悬停时显示图片 */
}
  </style>
  